<script>
import {mapState} from 'vuex'
export default {
  name: "NotFound",
  computed: {
    ...mapState(['message']),
  },
}
</script>

<template>
<div>
  <div style="display: flex; justify-content: center; align-items: center">
    <v-card outlined style="border-radius: 0; max-width: 1000px; ">
      <v-card-title>Страница не найдена</v-card-title>
    </v-card>
  </div>
</div>
</template>

<style scoped>

</style>